import { getForumTop } from "@/service/forum";
const state = {
  menu: null,
  breadcrumb: null,
  meta: null,
};

const mutations = {
  FORUM_MENU: (state, data) => {
    state.menu = data;
  },

  BREADCRUMB: (state, data) => {
    state.breadcrumb = data;
  },
  META: (state, data) => {
    state.meta = data;
  },
};

const actions = {
  getForumMenu({ commit }) {
    return new Promise((resolve, reject) => {
      getForumTop()
        .then((response) => {
          const { data } = response;
          if (!data) {
            return reject("无法获取社区列表");
          }
          commit("FORUM_MENU", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setBreadcrumb({ commit }, items) {
    commit("BREADCRUMB", items);
  },
  setMeta({ commit }, items) {
    commit("META", items);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
